import { useEffect, useCallback, useState, useRef } from 'react';
const useBlockNavigation = _ref => {
  let {
    shouldBlockNavigation,
    hashHistory,
    ensureRoute,
    confirmPromise
  } = _ref;
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const nextRoute = useRef('');
  const hasResponded = useRef(false);
  const unblockRef = useRef(null);
  useEffect(() => {
    if (!hasResponded.current && shouldBlockNavigation && hashHistory) {
      unblockRef.current = hashHistory.block(_ref2 => {
        let {
          location,
          retry
        } = _ref2;
        setIsBlockModalOpen(true);
        nextRoute.current = location.pathname;
        return false;
      });
    }
    return () => {
      if (unblockRef.current) {
        unblockRef.current();
      }
    };
  }, [hashHistory, shouldBlockNavigation]);
  const unblockAndNavigate = useCallback(() => {
    if (unblockRef.current) {
      unblockRef.current();
    }
    if (nextRoute.current && ensureRoute) ensureRoute(nextRoute.current);
  }, [ensureRoute]);
  const onConfirmAndUnblock = useCallback(() => {
    setIsBlockModalOpen(false);
    hasResponded.current = true;
    if (!confirmPromise) {
      unblockAndNavigate();
      return;
    }
    confirmPromise().then(() => {
      unblockAndNavigate();
    });
  }, [unblockAndNavigate, confirmPromise]);
  const onCancelAndUnblock = useCallback(() => {
    setIsBlockModalOpen(false);
    hasResponded.current = true;
    unblockAndNavigate();
  }, [unblockAndNavigate]);
  return {
    isBlockModalOpen,
    onConfirmAndUnblock,
    onCancelAndUnblock
  };
};
export default useBlockNavigation;